export class EstimatedCosts {
    accommodationExpenses?: number;
    conferenceFee?: number;
    transportationCosts?: number;
    otherEstimatedCosts?: number;
    sumOfEstimatedCosts?: number;
    reductionOfEstimatedCosts?: number;
}
